import { AverageRevenuePerCustomer } from './average-revenue-customer';
import { AverageRevenueCustomersDTO } from '../dto/average-revenue-customers.dto';
import { AverageRevenuePerCustomerDTO } from '../dto/average-revenue-customer.dto';

export class AverageRevenueCustomers {
  public total: number;
  public averageRevenuePerCustomer: Array<AverageRevenuePerCustomer>;

  public static fromDTO(
    averageRevenueCustomersDto: AverageRevenueCustomersDTO
  ): AverageRevenueCustomers {
    const average: AverageRevenueCustomers = new AverageRevenueCustomers();
    average.total = averageRevenueCustomersDto.totalAvgRevenuePerCustomer;
    average.averageRevenuePerCustomer = averageRevenueCustomersDto.avgRevenuePerCustomer.map(
      (revenuePerCustomerDto: AverageRevenuePerCustomerDTO) => {
        return AverageRevenuePerCustomer.fromDTO(revenuePerCustomerDto);
      }
    );
    return average;
  }
}
